import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body3 } from '../../../../../../atomic/text/Text';

type Props = {
  tradePlanId: string;
};

export const PositionComponent = ({ tradePlanId }: Props) => {
  const { tradePlanStore } = useWebsocketStore();
  const position = tradePlanStore.getTradePlanPosition(tradePlanId);
  const size = position?.quantity ?? '--';
  const fill =
    position == null ? '--' : ApplyRounding(position.avg_fill_price, 2);
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          Size:{' '}
        </Body3>
        <Body3 color={colors.lightGrey}> {size}</Body3>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          Fill:{' '}
        </Body3>
        <Body3 color={colors.lightGrey}> {position == null ? fill : `$${fill}`}</Body3>
      </div>
    </div>
  );
};
